import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ToggleSerie {
    id: string;
    label: string;
    color: string;
    isDefault: boolean;
}

@Component({
    selector: 'app-series-toggle',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="flex flex-wrap items-center gap-2">
            <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mr-1">Series:</span>
            <button
                *ngFor="let serie of series"
                (click)="toggle(serie)"
                [title]="isActive(serie.id) ? 'Ocultar ' + serie.label : 'Mostrar ' + serie.label"
                class="series-chip"
                [class.active]="isActive(serie.id)"
                [style.--chip-color]="serie.color">
                <span class="chip-dot" [style.background]="serie.color"></span>
                {{ serie.label }}
            </button>
        </div>
    `,
    styles: [`
        .series-chip {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px 12px 4px 8px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.03em;
            border: 1.5px solid #e2e8f0;
            background: white;
            color: #64748b;
            cursor: pointer;
            transition: all 0.18s ease;
            user-select: none;
        }
        .series-chip:hover {
            transform: scale(1.04);
            border-color: var(--chip-color);
            color: var(--chip-color);
        }
        .series-chip.active {
            background: var(--chip-color);
            border-color: var(--chip-color);
            color: white;
        }
        .series-chip.active .chip-dot {
            background: white !important;
        }
        .chip-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            flex-shrink: 0;
        }
    `],
})
export class SeriesToggle {

    @Input() series: ToggleSerie[] = [];
    @Input() activeSeries: string[] = [];
    @Output() activeSeriesChange = new EventEmitter<string[]>();

    isActive(id: string): boolean {
        return this.activeSeries.includes(id);
    }

    toggle(serie: ToggleSerie): void {
        const isNowActive = this.isActive(serie.id);
        // Prevent deactivating the last series
        if (isNowActive && this.activeSeries.length === 1) return;

        const next = isNowActive
            ? this.activeSeries.filter(id => id !== serie.id)
            : [...this.activeSeries, serie.id];

        this.activeSeriesChange.emit(next);
    }
}
